var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{attrs:{"placeholder":'Type to search',"options":_vm.search_label_options,"loading":_vm.search_label_loading,"clear_on_select":false},on:{"updated_search_value":_vm.search_label_value_updated,"select":_vm.on_select}})
}
var staticRenderFns = []

export { render, staticRenderFns }